import { render, staticRenderFns } from "./CustomViewList.vue?vue&type=template&id=04892dfd&scoped=true"
import script from "./CustomViewList.vue?vue&type=script&lang=js"
export * from "./CustomViewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04892dfd",
  null
  
)

export default component.exports